export default class Details {
	constructor(root) {
		if ((!root) instanceof HTMLDetailsElement) {
			console.error('`Details` can only be used on a `HTMLDetailsElement`');
			return false;
		}

		this.summary = root.querySelector('summary');

		if (!this.summary) {
			console.error('`Details` expects a `<summary>` element. It seems to be missing.');
			return false;
		}
	}

	open() {}

	close() {}
}
